import React, { useState } from "react";
import { Typography, Box, Tab, Button, TextField, IconButton } from "@mui/material";
import SpaceBetweenInput from "components/SpaceBetweenInput";
import Divider10 from "components/Divider10";
import DivInline from "components/DivInline";
import { showBigProgress, hideBigProgress } from "actions/screenActions";
import { createZoneControl } from "actions/zcActions";
import { mapAddDevice } from "actions/mapActions";
import DivExist from "components/DivExist";
import SpaceBetweenSelect from "components/SpaceBetweenSelect";
import IconButtonBack from "components/IconButtonBack";
import ZoneControlIcon from "components/ZoneControlIcon";
import { mgFindOne } from "actions/mongoApiActions";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Search } from "@mui/icons-material";
export default function AddZcToMapPanel({
  handleClose,
  targetX,
  targetY,
  state,
  dispatch,
  modalSize,
  deviceType,
  nameOfDevice,
}) {

  const { activeMapID } = state;
  const [name, setName] = useState("");
  const [selectedDeviceType, setSelectedDeviceType] = useState(""); //zcSceneButton, timer, zcSwitch
  const [addMode, setAddMode] = useState("create");
  const [importID, setImportID] = useState("");
  const [importObj, setImportObj] = useState(null);
  const deviceTypeUse = deviceType || selectedDeviceType;
  const handleSave = async () => {
    showBigProgress(dispatch);
    if (addMode === "create") {
      await createZoneControl(activeMapID, deviceTypeUse, name, targetX, targetY);
    } else {
      await mapAddDevice(activeMapID, importObj.zoneControlID, "zoneControl", importObj, targetX, targetY);
    }
    hideBigProgress(dispatch);
    handleClose();
  };
  const searchDb = async () => {
    const obj = await mgFindOne("zoneControl", "zoneControlID", importID);
    setImportObj(obj);
  }
  return (
    <>
      <DivInline hide={modalSize === "small"}>
        <IconButtonBack onBtnClick={handleClose} />
        <Typography variant="h6">Add {nameOfDevice}</Typography>
      </DivInline>
      <TabContext value={addMode || "create"}>
        <TabList onChange={(evt, newTab) => setAddMode(newTab)}>
          <Tab label="Create" value="create" />
          <Tab label="Import" value="import" />
        </TabList>
        <TabPanel value="create">
          <DivExist show={!deviceType}>
            <Divider10 space={5} />
            <SpaceBetweenSelect
              title="Device Type"
              data={selectedDeviceType || ""}
              onChangeValue={(value) => setSelectedDeviceType(value)}
              menuObj={{
                timer: "Vitural Timer",
                zcSceneButton: "Vitural Button",
                zcSwitch: "VituralSwitch",
              }}
            />
          </DivExist>
          <Divider10 space={5} />
          <SpaceBetweenInput
            data={name}
            title="Name"
            onInput={(e) => setName(e.target.value)}
          />
          <Divider10 space={5} />
          <DivExist show={deviceTypeUse}>
            <DivInline justifyContent="center">
              <ZoneControlIcon type={deviceTypeUse} width={4} sizeUnit={'vw'} />
            </DivInline>
            <Divider10 space={5} />
          </DivExist>
          <Button variant="outlined" fullWidth onClick={handleSave} disabled={!name || !deviceTypeUse}>Create</Button>

        </TabPanel>
        <TabPanel value="import">
          <Box sx={{ width: "100%" }}>
            <DivInline justifyContent="space-between" sx={{ width: "100%" }}>
              <Typography>Zone control ID</Typography>
              <DivInline alignItems="center">
                <TextField
                  value={importID || ""}
                  onChange={(e) => setImportID(e.target.value)}

                />
                <IconButton onClick={searchDb}>
                  <Search />
                </IconButton>
              </DivInline>
            </DivInline>
            <Divider10 space={5} />
            <DivExist show={importObj}>

              <Typography>{importObj?.zoneControlName}</Typography>
              <DivInline justifyContent="center">
                <ZoneControlIcon type={importObj?.type} width={4} sizeUnit={'vw'} />
              </DivInline>
              <Divider10 space={5} />
            </DivExist>
            <Button variant="outlined" fullWidth onClick={handleSave} disabled={!importObj}>Import</Button>
          </Box>
        </TabPanel>
      </TabContext>
    </>
  );
}
